import { useRef, useState, useMemo, useEffect } from "react";
import { CONTENT_W } from "./chunk-0.jsx";
import { ANI_H, ANI_PEYES, ANI_W, aniMoodIdFromEmotion, drawBitmap, getAniFrameBytes } from "./chunk-1.jsx";
export function AniEyes({
  emotion,
  heartbeatRef,
  active = true,
  motionBoost = false
}) {
  const canvasRef = useRef(null);
  const [pos, setPos] = useState(0);
  const moodId = useMemo(() => aniMoodIdFromEmotion(emotion), [emotion]);
  const frameNames = useMemo(() => ANI_PEYES[moodId]?.[pos] || ANI_PEYES[1][0], [moodId, pos]);
  useEffect(() => {
    if (!active) return;
    const timer = setInterval(() => setPos(p => (p + 1) % 3), motionBoost ? 360 : 450);
    return () => clearInterval(timer);
  }, [active, motionBoost]);
  useEffect(() => {
    if (!active) return;
    heartbeatRef.current = Date.now();
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.imageSmoothingEnabled = false;
    ctx.fillStyle = '#000';
    ctx.fillRect(0, 0, ANI_W, ANI_H);
    const left = getAniFrameBytes(frameNames[0]);
    const right = getAniFrameBytes(frameNames[1]);
    if (!left || !right) return;

    // Official coordinates from eyes.h: l_X=20, r_X=74, y=8, w=h=32.
    drawBitmap(ctx, 20, 8, left, 32, 32, 1);
    drawBitmap(ctx, 74, 8, right, 32, 32, 1);
  }, [active, frameNames, heartbeatRef, motionBoost, pos]);
  return <div className="w-full h-full flex items-center justify-center">
      <canvas ref={canvasRef} width={ANI_W} height={ANI_H} className="block w-full h-auto" style={{
      imageRendering: 'pixelated',
      maxWidth: CONTENT_W
    }} />
    </div>;
}
export const ESP32_EXPRESSION_PRESETS = {
  Normal: {
    left: 'Preset_Normal',
    right: 'Preset_Normal'
  },
  Angry: {
    left: 'Preset_Angry',
    right: 'Preset_Angry'
  },
  Glee: {
    left: 'Preset_Glee',
    right: 'Preset_Glee'
  },
  Happy: {
    left: 'Preset_Happy',
    right: 'Preset_Happy'
  },
  Sad: {
    left: 'Preset_Sad',
    right: 'Preset_Sad'
  },
  Worried: {
    left: 'Preset_Worried_Alt',
    right: 'Preset_Worried'
  },
  Focused: {
    left: 'Preset_Focused',
    right: 'Preset_Focused'
  },
  Annoyed: {
    left: 'Preset_Annoyed_Alt',
    right: 'Preset_Annoyed'
  },
  Surprised: {
    left: 'Preset_Surprised',
    right: 'Preset_Surprised'
  },
  Skeptic: {
    left: 'Preset_Skeptic_Alt',
    right: 'Preset_Skeptic'
  },
  Frustrated: {
    left: 'Preset_Frustrated',
    right: 'Preset_Frustrated'
  },
  Unimpressed: {
    left: 'Preset_Unimpressed_Alt',
    right: 'Preset_Unimpressed'
  },
  Sleepy: {
    left: 'Preset_Sleepy_Alt',
    right: 'Preset_Sleepy'
  },
  Suspicious: {
    left: 'Preset_Suspicious_Alt',
    right: 'Preset_Suspicious'
  },
  Squint: {
    left: 'Preset_Squint_Alt',
    right: 'Preset_Squint'
  },
  Furious: {
    left: 'Preset_Furious',
    right: 'Preset_Furious'
  },
  Scared: {
    left: 'Preset_Scared',
    right: 'Preset_Scared'
  },
  Awe: {
    left: 'Preset_Awe',
    right: 'Preset_Awe'
  }
};
